import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {from, iif, Observable, throwError} from 'rxjs';
import {AuthService} from 'src/app/services/auth.service';
import {catchError, mergeMap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Storage} from '@ionic/storage-angular';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private storage: Storage
  ) {}

  private customerRoutes = [ 'wizard-event' ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let observable: Observable<any>; // TODO: type as token
    const urlTree = this.router.createUrlTree([this.router.url]);
    if (
      urlTree.root.hasChildren() &&
      urlTree.root.children.primary && 
      urlTree.root.children.primary.segments.some(segment => this.customerRoutes.includes(segment.path))
    ) {
      // If no 'self' URL tree segment exists, that means a customer route was called with an external ID, use customer token in this case instead of user token
      if (!urlTree.root.children.primary.segments.some(segment => segment.path === 'self')) {
        observable = from(this.authService.getCustomerToken());
      }
    }

    if (!observable) {
      observable = from(this.authService.getUserToken());
    }

    // Add JWT token as X-Authorization either from user or customer token
    return observable.pipe(
      mergeMap(token => {
        console.log(token);
        if (token) {
          return next
            .handle(
              req.clone({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                setHeaders: {'X-Authorization': `JWT ${token}`}
              })
            )
            .pipe(
              catchError(err => {
                if (err.status === 401) {
                  this.storage.remove('company_id');
                  this.storage.remove('JWT');
                  console.log('ERROR ', err);
                  if (window.location !== window.parent.location) {
                    this.router.navigate(['clogin']);
                  } else {
                    this.router.navigate(['login']);
                  }
                }
                return throwError(err); //Rethrow it back to component
              })
            );
        }
    
        return next.handle(req);
      })
    );
  }
}
